import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import KardexCliente from "../views/KardexCliente.vue";
// import Billing from "../views/Billing.vue";
import Profile from "../views/Profile.vue";
import Login from "../views/auth/Login.vue";
// import Register from "../views/auth/Register.vue";
import RegistrarAfilicion from "../views/RegistrarAfilicion.vue";
import Validar from "../views/Validar.vue";
import GestionarAfiliaciones from "../views/GestionarAfiliaciones.vue";
import ReporteGeneral from "../views/ReporteGeneral.vue";
import AdminProgramas from "../views/AdminProgramas.vue";
import AdminUsuarios from "../views/AdminUsuarios.vue";
import AdminAgencias from "../views/AdminAgencias.vue";
import ConfigSOA from "../views/ConfigSOA.vue";
import LogSOA from "../views/LogSOA.vue";
import ConsultaAfiliados from "../views/ConsultaAfiliados.vue";
import LogConsultaAfiliados from "../views/LogConsultaAfiliados.vue";
import Afiliados from "../views/Afiliados.vue";
import ReporteVentas from "../views/ReporteVentas.vue";
import ReporteAnulaciones from "../views/ReporteAnulaciones.vue";
import Home from "../views/Home.vue";

import AdminCondicionados from "../views/AdminCondicionados.vue";
import ProcesarPago from "../views/ProcesarPago.vue";
import Validacion from "../views/Validacion.vue";
import Contactanos from "../views/Contactanos.vue";
import StepGeneracionCertificado from "../views/StepGeneracionCertificado.vue";
import auth from "../middleware/auth";
import guest from "../middleware/guest";
import placeholder from "../assets/img/placeholder.jpg";
// import HighchartWrapper from "../views/HighchartWrapper.vue";
const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/login",
  },
  {
    path: "/afiliacion",
    name: "Afiliación",
    component: RegistrarAfilicion,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/afiliaciones-addiuva/:id",
    name: "Afiliaciones Addiuva",
    component: ProcesarPago,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/afiliacion-addiuva/:id",
    name: "Afiliación Addiuva",
    component: StepGeneracionCertificado,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/validar",
    name: "Validar",
    component: Validar,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/gestionar-afiliaciones",
    name: "Gestión de Afiliaciones",
    component: GestionarAfiliaciones,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/reporte-general",
    name: "Reporte General",
    component: ReporteGeneral,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/imgBackgroundLogin",
    name: "imgBackgroundLogin",
    component: placeholder,
  },
  {
    path: "/admin-usuarios",
    name: "Administración de Usuarios",
    component: AdminUsuarios,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/admin-agencias",
    name: "Administración de Agencias",
    component: AdminAgencias,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/admin-programas",
    name: "Administración de Programas",
    component: AdminProgramas,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/config-soa",
    name: "Parametros SOA",
    component: ConfigSOA,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/log-soa",
    name: "Log SOA",
    component: LogSOA,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/consulta-afiliados",
    name: "Consulta de Afiliados",
    component: ConsultaAfiliados,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/catalogo-medicamentos", // 1. Usa una ruta interna que empiece con "/"
    name: "Catálogo de Medicamentos",
    meta: {
      middleware: auth, // Tu middleware seguirá protegiendo el acceso
    },
    beforeEnter() {
      // 2. Redirige a la URL externa una vez que se intente acceder a esta ruta
      // window.location.href = "https://catalogomedicamentos.infinityfree.me/";
      // NOTA: Si prefieres que el catálogo se abra en una nueva pestaña, 
      // comenta la línea de arriba y usa estas dos líneas en su lugar:
      window.open("https://catalogomedicamentos.infinityfree.me/", "_blank");
      // next(false); // Detiene la navegación en la pestaña actual
    }
  },
  {
    path: "/log-consulta-afiliados",
    name: "Log Consulta de Afiliados",
    component: LogConsultaAfiliados,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/afiliados",
    name: "Afiliados",
    component: Afiliados,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/reporte-ventas",
    name: "Reporte de Ventas",
    component: ReporteVentas,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/reporte-anulaciones",
    name: "Reporte de Anulaciones",
    component: ReporteAnulaciones,
    meta: {
      middleware: auth,
    },
  },

  {
    path: "/admin-condicionados",
    name: "Administración de Condicionados",
    component: AdminCondicionados,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/kardex-cliente",
    name: "Kardex Cliente",
    component: KardexCliente,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/validacion",
    name: "Validacion",
    component: Validacion,
  },
  {
    path: "/contactanos",
    name: "Contactanos",
    component: Contactanos,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      middleware: guest,
    },
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      middleware: auth,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// Creates a nextMiddleware() function which not only
// runs the default next() callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default next() callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router next() callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // nextMiddleware() callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];
    const context = { from, next, to, router };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

export default router;
